module.exports = __webpack_public_path__ + "static/media/highlight-1.3ae6afa3.png";